import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import roTranslations from './locales/ro.json';

// Custom detector to read locale from URL path
const pathDetector = {
  name: 'path',
  lookup() {
    if (typeof window === 'undefined') return null;
    const path = window.location.pathname;
    const match = path.match(/^\/(ro|en)(\/|$)/);
    return match ? match[1] : null;
  },
  cacheUserLanguage(lng: string) {
    if (typeof window !== 'undefined') {
      localStorage.setItem('i18nextLng', lng);
    }
  },
};

// Sync <html lang="..."> with the active i18n language (accessibility + BDD assertions).
// Registered before init(): with inline resources init() fires languageChanged synchronously,
// so a listener added afterwards misses the first language and the static lang="ro" from
// index.html stays on English pages (JUB-187).
function syncDocumentLanguage(lng: string | undefined): void {
  if (typeof document !== 'undefined' && lng) {
    document.documentElement.lang = lng;
  }
}
i18n.on('languageChanged', syncDocumentLanguage);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      ro: {
        translation: roTranslations,
      },
    },
    fallbackLng: 'ro',
    defaultNS: 'translation',
    supportedLngs: ['ro', 'en'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false, // Disable suspense for better compatibility
    },
  });

// Add custom path detector
if (i18n.services.languageDetector) {
  i18n.services.languageDetector.addDetector(pathDetector);
}

// Belt and braces: whatever the event ordering, the attribute matches the resolved language.
syncDocumentLanguage(i18n.language);

export default i18n;
